import { useRouter } from 'next/router'

import { setDealAdvisorTab } from '../../client/generalSlice'
import { openFiles } from '../../features/FileManager/utilities'
import { alertMessage } from './alert'
import useAtypicalityAlerts from './useAtypicalityAlerts'
import { useAppDispatch } from '@/client/hooks'
import { useDocuments } from '@/features/FileManager/useDocuments'
import { AtypicalityCheckCalcs } from '@/types/unlock'

export const useAlertResolve = (id: string | string[]) => {
  const router = useRouter()
  const dispatch = useAppDispatch()
  const { data: documents } = useDocuments()
  const atypicalityAlerts = useAtypicalityAlerts({} as AtypicalityCheckCalcs)

  const openCreditReport = () => {
    const creditReportDocs = documents.filter((doc) =>
      doc.fileName?.toLowerCase().includes('credit report')
    )
    openFiles(creditReportDocs, id)
  }

  const openAlertDestination = (message: string) => {
    try {
      if (alertMessage[message]?.tab) {
        dispatch(setDealAdvisorTab(alertMessage[message]?.tab))
      }

      let alertPath = alertMessage[message]?.path
      if (!alertPath && message in atypicalityAlerts) {
        alertPath = atypicalityAlerts[message].path
      }

      const destinations: string[] = []
      if (Array.isArray(alertPath)) {
        destinations.push(...alertPath)
      } else if (typeof alertPath === 'string') {
        destinations.push(alertPath)
      }

      destinations.forEach((destination, idx) => {
        if (destination === 'maxViewerCreditReports') {
          openCreditReport()
          return
        }

        const pathToNavigate = `/applications/${id}/${destination}`

        if (destinations.length === 1) {
          router.push(pathToNavigate)
        } else if (idx === 0) {
          window.location.href = pathToNavigate
        } else {
          window.open(pathToNavigate, '_blank')
        }
      })
    } catch (error) {
      console.error(error)
    }
  }

  return {
    openAlertDestination,
  }
}
